/* Kumii free gift: keeps exactly one "Tasuta kingitus" line in the cart, matching the product total.
 *
 * Tiers (Marilyn, 2026-10-21): every order 1–2 testers, from 35 € a sheet mask + tester, from 60 € a
 * mini-size product + testers, from 100 € a full-size product. Tiers and gift variant ids come from #kumii-gift-config
 * (layout/theme.liquid), which only renders while the gift product is available, so nothing runs
 * while it is a draft. Marilyn sees the gift line in the order and packs the gift.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('kumii-gift-config');
  if (!configEl || !window.FoxTheme) return;

  var tiers = JSON.parse(configEl.textContent); // [{min: cents, variant: id}], ascending
  var giftIds = tiers.map(function (t) { return t.variant; });
  var running = false;
  var again = false;
  var broken = false;

  function isGift(item) {
    return giftIds.indexOf(item.variant_id) !== -1;
  }

  // Product total after discounts, without the gift itself.
  function targetVariant(cart) {
    var total = cart.items.filter(function (i) { return !isGift(i); })
      .reduce(function (sum, i) { return sum + i.final_line_price; }, 0);
    var target = null;
    tiers.forEach(function (t) { if (total >= t.min) target = t.variant; });
    return target;
  }

  function inSync(cart, target) {
    var gifts = cart.items.filter(isGift);
    if (!target) return gifts.length === 0;
    return gifts.length === 1 && gifts[0].variant_id === target && gifts[0].quantity === 1;
  }

  async function sync(cart) {
    if (broken) return;
    if (running) { again = true; return; }
    running = true;
    try {
      if (!cart || !cart.items) cart = await (await fetch(FoxTheme.routes.cart_url + '.js')).json();
      var target = targetVariant(cart);
      if (inSync(cart, target)) return;

      var updates = {};
      giftIds.forEach(function (id) { updates[id] = 0; });
      if (target) updates[target] = 1;
      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );
      var response = await fetch(FoxTheme.routes.cart_update_url, Object.assign(FoxTheme.utils.fetchConfig(), {
        body: JSON.stringify({ updates: updates, sections: sections }),
      }));
      if (!response.ok) { broken = true; return; }
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        cart: await response.json(),
        source: 'kumii-gift',
      });
    } catch (error) {
      broken = true;
      console.error('Kumii gift:', error);
    } finally {
      running = false;
      if (again) { again = false; sync(); }
    }
  }

  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!event || event.source === 'kumii-gift' || !event.cart || event.cart.errors) return;
    sync(event.cart);
  });
  sync();
})();
